import { createAction, props } from '@ngrx/store';
import { ISCDUser, IUser } from '@app-root-interfaces';
import { IProfile } from '@scf-monorepo/interfaces';

export const createInitialProfile = createAction('[Profile] Create initial profile', props<{ scdUser: ISCDUser }>());

export const getScdUserForInitialProfileCreate = createAction(
    '[User] Get SCD user for initial profile create',
    props<{ gid: string }>()
);

export const createInitialProfileSuccess = createAction(
    '[Profile] Create initial profile success',
    props<{ profile: IProfile }>()
);

export const getUserProfiles = createAction('[Profile] Get user profiles', props<{ user: IUser }>());

export const getUserProfilesSuccess = createAction(
    '[Profile] Get user profiles success',
    props<{ profiles: IProfile[] }>()
);

export const checkForProfileUpdate = createAction(
    '[Profile] Check for profile update',
    props<{ profiles: IProfile[]; user: IUser }>()
);

export const updateProfileFromScd = createAction(
    '[Profile] Update profile from scd',
    props<{
        scdUser: ISCDUser;
        profiles: IProfile[];
        profileId: string;
        user: IUser;
        isActive?: boolean;
    }>()
);

export const copyProfileAndSetActive = createAction(
    '[Profile] Copy a profile and set active',
    props<{ profile: IProfile }>()
);

export const copyProfileAndSetActiveSuccess = createAction(
    '[Profile] Copy a profile and set active success',
    props<{ profiles: IProfile[] }>()
);

export const activateProfile = createAction('[Profile] Activate profile', props<{ profile: IProfile }>());

export const activateProfileSuccess = createAction(
    '[Profile] Activate profile success',
    props<{ profiles: IProfile[] }>()
);

export const selectProfile = createAction('[Profile] Select profile success', props<{ id: string }>());

export const updateProfile = createAction('[Profile] Update profile', props<{ profile: IProfile }>());

export const updateProfileSuccess = createAction('[Profile] Update profile success', props<{ profile: IProfile }>());

export const updateProfileFailure = createAction('[Profile] Update profile failure');

export const updateAdminProfile = createAction('[Profile] Update admin profile', props<{ profile: IProfile }>());

export const updateAdminProfileSuccess = createAction(
    '[Profile] Update admin profile success',
    props<{ profile: IProfile }>()
);

export const deleteProfile = createAction('[Profile] Delete profile', props<{ profile: IProfile }>());

export const deleteProfileSuccess = createAction('[Profile] Delete profile success', props<{ profile: IProfile }>());

export const changeSelectionAndDelete = createAction(
    '[Profile] change selected profile and delete',
    props<{ profile: IProfile }>()
);

export const changeSelectionAndDeleteSuccess = createAction(
    '[Profile] Change selected profile and delete success',
    props<{ deletedProfile: IProfile; userProfile: IProfile }>()
);

export const createSCDProfile = createAction('[Profile] Create scd profile', props<{ scdUser: ISCDUser }>());

export const createSCDProfileSuccess = createAction(
    '[Profile] Create scd profile success',
    props<{ profile: IProfile }>()
);

export const checkProfileInformations = createAction('[Profile] Check profile informations');
export const checkProfileInformationsSuccess = createAction('[Profile] Check profile informations success');
export const checkProfileInformationsFailure = createAction('[Profile] Check profile informations failure');

export const setProfileValidity = createAction(
    '[Profile] Set profile validity',
    props<{ profile: IProfile; valid: boolean }>()
);

export const setThemeByUserProfile = createAction(
    '[Profile] Set Theme by User Profile',
    props<{ profile: IProfile }>()
);

export const setThemeSuccess = createAction('[Profile] Set Theme Success');

export const doNothing = createAction('[All] Do nothing');
